import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../../Moduels/Context/AuthContext";
import { normalizeRole } from "../../../rbac/access";

export default function AttendanceIndexRedirect() {
  const { role } = useContext(AuthContext);
  if (normalizeRole(role) === "employee") {
    return <Navigate to="/my-attendance" replace />;
  }
  return <Navigate to="/attendance/dashboard" replace />;
}
